module.exports = __webpack_public_path__ + "img/showcase-content-en-ca.a2267ebb.jpg";